<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import { alpha } from "@/helpers/helper";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      plan: {
        names: "",
        name: "",
        type: "",
        price: "",
        pay_status: "",
        status: true,
      },
      priceSeen: false,
      color: {
        "text-danger": true,
      },
      title: "Plans",
      items: [
        {
          text: "plan",
          href: "/plans",
        },
        {
          text: "Edit",
          active: true,
        },
      ],
    };
  },
  validations: {
    plan: {
      name: {
        required,
        alpha,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      price: {
        required: requiredIf(function () {
          return this.plan.type === "Paid";
        }),
      },
    },
  },
  computed: mapGetters("plan", ["loading", "planCount", "plans", "paginations"]),
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("plan", ["showPlan", "updatePlan"]),
    init() {
      let id = this.$route.params.id;
      this.showPlanName(id);
    },
    showPlanName(id) {
      this.showPlan(id).then((res) => {
        this.plan = {
          name: res.name,
          names: res.name,
          status: res.status,
          type: res.pay_status,
          price: res.price,
        };
      });
    },
    update() {
      let id = this.$route.params.id;
      this.$v.plan.$touch();
      if (this.$v.plan.$invalid) {
        return;
      } else {
        var data = { ...this.plan, id: id };

        this.updatePlan(data).then((res) => {
          if (res) this.$router.push({ name: "plan.list" });
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-4">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div class="card">
          <div class="card-header">
            <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
            >
              <div class="page-title-left avatar-main-icon" style="display: flex">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                  >
                    <i class="bx bx-user-circle"></i>
                  </span>
                </div>
                <div class="report-tag">
                  <h4 class="mb-0 font-size-18">{{ plan.names }}</h4>
                  <p>
                    <router-link :to="{ name: 'plan.list' }">Plan </router-link>
                    > {{ plan.names }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="update">
              <div class="row">
                <input type="hidden" class="form-control" name="id" v-model="plan.id" />
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Name <span :class="color">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="plan.name"
                      :class="{ 'is-invalid': $v.plan.name.$error }"
                      placeholder="Name"
                    />
                    <div v-if="$v.plan.name.$error" class="invalid-feedback">
                      <span v-if="!$v.plan.name.required"> Please enter name</span>
                      <span v-if="!$v.plan.name.minLength">
                        {{ $t("Name should not less than 3") }}</span
                      >
                      <span v-if="!$v.plan.name.maxLength">
                        {{ $t("Name should not more than 100") }}</span
                      >
                    </div>
                  </div>
                </div>
                <!-- {{options}} -->
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Type</label>
                    <input
                      type="type"
                      class="form-control"
                      name="type"
                      v-model="plan.type"
                      placeholder="Type"
                      readonly
                    />
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Status</label>
                    <b-form-checkbox
                      switch
                      size="lg"
                      v-model="plan.status"
                      class="ml-1"
                    ></b-form-checkbox>
                  </div>
                </div>

                <div class="col-6 mb-2" v-if="plan.type == 'Paid'">
                  <div class="form-group">
                    <label>Price<span :class="color">*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      name="price"
                      v-model="plan.price"
                      placeholder="Price"
                      :class="{ 'is-invalid': $v.plan.price.$error }"
                      min="1"
                    />
                    <div v-if="$v.plan.price.$error" class="invalid-feedback">
                      <span v-if="!$v.plan.price.required"> Please enter price</span>
                    </div>
                  </div>
                </div>

                <div class="col-12 pt-4">
                  <button type="submit" class="btn btn-primary">Update</button>
                  <b-button
                    @click="$router.back()"
                    type="button"
                    variant="secondary"
                    class="ml-3"
                    >Cancel
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
